module.exports = __webpack_public_path__ + "static/media/fun7.00cc5ba4.png";